// extracted by mini-css-extract-plugin
export default {"buttonBack":"ButtonBack_buttonBack__7eYha","icon":"ButtonBack_icon__qbKVc"};